// All or portions of this file Copyright © 2019 Amazon Web Services, Inc. or its affiliates or licensors.
// All rights reserved. For full license terms and conditions, please see the LICENSE file at the root of
// this distribution (the "License") or go to https://content.sumerian.amazonaws.com/engine/latest/license.txt.
// All use of the software is governed by the License. All materials are made available on an "AS IS" BASIS, WITHOUT
// WARRANTIES OR CONDITIONS OF ANY KIND, express or implied. Do not remove or modify any license notices.
import TransformData from '../../animationpack/clip/TransformData';

/**
 * Describes transform of a joint.
 */
class JointData extends TransformData {

  /**
   * @param {JointData} [source] source to copy
   */
  constructor(source) {
    super(source);
    this._jointIndex = source ? source._jointIndex : undefined;
  }

  /**
   * Copy the jointData's values into this transform data object.
   * @param {JointData} jointData our source to copy. Must not be null.
   */
  set(jointData) {
    super.set(jointData);
    this._jointIndex = jointData._jointIndex;
  }

  /**
   * Blend this transform with the given transform.
   * @param {TransformData} blendTo The blend target to blend to
   * @param {number} blendWeight The blend weight
   * @param {TransformData} store The transform store.
   * @param {boolean} [isAdditive] The blendTo is treated as additive when this is true. Defaults to false.
   * @returns {TransformData} The blended transform.
   */
  blend(blendTo, blendWeight, store, isAdditive=false) {
    let rVal = store;
    if (!rVal) {
      rVal = new JointData();
      rVal._jointIndex = this._jointIndex;
    } else if (rVal instanceof JointData) {
      rVal._jointIndex = this._jointIndex;
    }
    return TransformData.prototype.blend.call(this, blendTo, blendWeight, rVal, isAdditive);
  }

  clone() {
    return new JointData(this);
  }
}

export default JointData;
